@if (step == 'project') {
    <div class="modal-inner">
        <h1>Kies een project</h1>
        @if (settlement.afas_project_id) {
            <h2>
                Huidig: <strong>{{ settlement.afas_project_id }}</strong>
            </h2>
        }
        <input [formControl]="fcProjectSearch" placeholder="Zoeken in projecten" />
        <div class="results">
            @if (searching) {
                <div class="result text-center">aan het zoeken...</div>
            }
            @for (project of projects; track project) {
                <div class="result" (click)="form.controls.afas_project_id.setValue(project.projectId); saveAndClose()">
                    <strong>{{ project.projectId }}</strong> {{ project.description }}
                </div>
            }
            @if (!searching && projects?.length == 0) {
                <div class="result">Geen projecten gevonden</div>
            }
        </div>
        <div class="buttons">
            <button class="planning-button cancel" mat-raised-button mat-dialog-close="">Annuleren</button>
        </div>
    </div>
}

@if (step == 'hourtype') {
    <div class="modal-inner">
        <h1>Kies een uursoort</h1>
        <h2>
            Huidig: <strong>{{ settlement.hourtype?.code }}</strong> {{ settlement.hourtype?.description }}
            <small>{{ settlement.hourtype?.type }}</small>
        </h2>
        <input [(ngModel)]="itemSearch" placeholder="Zoeken..." />
        <div class="results">
            @for (hourtype of hourtypes | search: 'description' : itemSearch; track hourtype) {
                <div class="result" (click)="form.controls.hourtype_code.setValue(hourtype.code); saveAndClose()">
                    <strong>{{ hourtype.code }}</strong> {{ hourtype.description }} <small>{{ hourtype.type }}</small>
                </div>
            }
        </div>
        <div class="buttons">
            <button class="planning-button cancel" mat-raised-button mat-dialog-close="">Annuleren</button>
        </div>
    </div>
}
